module.exports = __webpack_public_path__ + "static/media/Group 22.fe6fc052.svg";